/**
 * Event encapsulator.
 * @constructor
 * @param {string} name
 * @param {Foundation.Observable} target
 * @param {*=} data
 */
Foundation.Observable.Event = function (name, target, data) {
    /**
     * @public
     * @type {string}
     */
    this.name = this["name"] = name;
    
    /**
     * @public
     * @type {Foundation.Observable}
     */
    this.target = this["target"] = target;
    
    /**
     * @public
     * @type {*}
     */
    this.data = this["data"] = (data === undefined) ? null : data;
};

/**
 * @typedef {function(Foundation.Observable.Event=)}
 */
Foundation.Observable.Event.Handler;

